// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinny-icon{transition-property:transform;transition-duration:200ms;transition-timing-function:ease-out}", ""]);
// Exports
module.exports = exports;
